import React, { Component } from 'react'
import i18n from 'live/services/i18n'
import typeFn from './decorator'
import Text from './components/text'
import CodeMirror from 'live/components/codemirror/codemirror'
import FormGroup from 'live/components/forms/ui/form-group'
import FormBase from 'live/components/extensions/ui/form'
import styled from 'styled-components'

class HistoricalType extends Component {
    componentDidMount() {
        $('.CodeMirror').resizable({
            resize: function () {
                $('.CodeMirror').each(function (i, el) {
                    el.CodeMirror.refresh()
                })
            }
        })
    }
    render() {
        const { onChangeCode, onChange, validationState, errorsFor, config, handleValidation } = this.props
        const outputParams = config.outputParams || {}
        const { cron = '', runNowSpan = '' } = outputParams || {}

        return (
            <div>
                <div className={`form-group has-feedback has-${validationState('config.query')}`}>
                        <label htmlFor="config.query" className="control-label">
                            <span>
                                {' '}
                                {i18n('Query')}
                                <abbr title="required">*</abbr>
                            </span>
                        </label>
                        <CodeMirror
                            id="config.query"
                            value={config.query}
                            onChange={e => onChangeCode('query', e)}
                            options={{
                                mode: 'pipes',
                                matchBrackets: true,
                                lineNumbers: true,
                                foldGutter: true
                            }}
                        />
                        {validationState('config.query') === 'error' ? (
                            <div className="help-block">{errorsFor('config.query')}</div>
                        ) : null}

                        <FormGroup
                            type="text"
                            label={
                                <span>
                                    {i18n('Span')}
                                    <abbr title="required">*</abbr>
                                </span>
                            }
                            name="config.span"
                            value={config.span}
                            onChange={handleValidation}
                            validationState={validationState('config.span')}
                            hasFeedback
                            help={errorsFor('config.span')}
                        />
                    </div>
                <FormGroup
                        type="text"
                        label={
                            <span>
                                {i18n('Result key')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.key"
                        value={config.key}
                        onChange={handleValidation}
                        validationState={validationState('config.key')}
                        hasFeedback
                        help={errorsFor('config.key')}
                    />

                    <FormGroup
                        type="text"
                        label={
                            <span>
                                {i18n('Result value')}
                                <abbr title="required">*</abbr>
                            </span>
                        }
                        name="config.value"
                        value={config.value}
                        onChange={handleValidation}
                        validationState={validationState('config.value')}
                        hasFeedback
                        help={errorsFor('config.value')}
                    />
                <Text
                    label={i18n('Schedule')}
                    value={config.cron}
                    name="config.cron"
                    onChange={e => onChange('config.cron', e)}
                    validationState={validationState}
                    help={
                        errorsFor('config.schedule') ||
                        i18n("Period expression, or use 'realtime' to run immediately and follow results")
                    }
                />

                <Text
                    label={i18n('Optional: set span case save or run for the first time.')}
                    value={runNowSpan}
                    name="runNowSpan"
                    onChange={e => onChange('runNowSpan', e)}
                    validationState={validationState}
                    help={errorsFor('config.runNowSpan')}
                />
            </div>
        )
    }
}

export default typeFn({
    label: 'Historical Type',
    type: 'historical',
    properties: ['cron', 'runNowSpan'],
    config: {
        __validation_http_url: 'cron(0 * * * *)'
    },
    validations: {
        __validation_dynamic_cron: {
            required: true,
            allowEmpty: false,
            message: i18n('cron is required')
        }
    }
})(HistoricalType)
